const deviationTimeFormatter = (time: number) => {
  return `${time > 0 ? '+' : ''}${time}`;
};

export default deviationTimeFormatter;
